<template>
  <div>
    <manage-roles-modal />
    <v-text-field
      v-model="search"
      append-icon="search"
      label="Filter Roles"
      single-line
      hide-details
    />
    <v-data-table
      :headers="tableHeaders"
      :items="tableItems"
      :search="search"
      class="elevation-1"
      disable-pagination
      hide-default-footer
    >
      <template v-slot:item="props">
        <tr>
          <td class="justify-center">
            <v-btn tooltip.hover title="Edit Roles (Okta groups)" icon class="mx-0" @click="editItem(props.item)">
              <v-icon color="primary">edit</v-icon>
            </v-btn>
          </td>
          <td>{{ props.item.roleName }}</td>
          <td>{{ props.item.roleDescription }}</td>
          <td>{{ props.item.clientNameDesc }}</td>
          <td>{{ props.item.featureCnt }}</td>
          <td>{{ props.item.createdBy }}</td>
          <td>{{ props.item.createdOn | formatDate }}</td>
          <td>{{ props.item.lastModifiedBy }}</td>
          <td>{{ props.item.lastModifiedOn | formatDate }}</td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapMutations, mapActions } from 'vuex'
import ManageRolesModal from './ManageRolesModal'
export default {
  name: 'manage-roles-table',
  components: {
    ManageRolesModal
  },
  props: {
    tableItems: Array
  },
  data: () => ({
    search: '',
    tableHeaders: [
      {
        text: 'Actions',
        value: false,
        sortable: false
      },
      {
        text: 'Role Name',
        value: 'roleName'
      },
      {
        text: 'Role Description',
        value: 'roleDescription'
      },
      {
        text: 'Client',
        value: 'clientNameDesc'
      },
      {
        text: 'Total Features',
        value: 'featureCnt'
      },
      {
        text: 'Created By',
        value: 'createdBy'
      },
      {
        text: 'Created On',
        value: 'createdOn'
      },
      {
        text: 'Last Modified By',
        value: 'lastModifiedBy'
      },
      {
        text: 'Last Modified On',
        value: 'lastModifiedOn'
      }
    ]
  }),
  methods: {
    ...mapMutations({
      showRolesModal: 'manageRoles/setShowRolesModal',
      setEditedItemIndex: 'manageRoles/setEditedItemIndex',
      setEditedItem: 'manageRoles/setEditedItem'
    }),
    ...mapActions('manageRoles', ['getRoleDetails']),
    editItem(item) {
      const itemIndex = this.tableItems.indexOf(item)
      const editedItem = Object.assign({}, item)
      this.getRoleDetails({ itemIndex, editedItem })
      this.showRolesModal(true)
    }
  }
}
</script>
